import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getAllDrivingLicense = () => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.getAllDrivingLicense().then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETDRIVINGLICENSESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETDRIVINGLICENSEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETDRIVINGLICENSEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getDrivingLicenseById = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getDrivingLicenseById(id).then(res => {
        
        if (JSON.parse(res).status == 200) {
            
            dispatch({
                type: ActionTypes.GETDRIVINGLICENSEBYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETDRIVINGLICENSEBYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETDRIVINGLICENSEBYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const saveDrivingLicense = (data) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.saveDrivingLicense(data).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEDRIVINGLICENSESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEDRIVINGLICENSEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.SAVEDRIVINGLICENSEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const updateDrivingLicense = (data, id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.updateDrivingLicense(data, id).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.UPDATEDRIVINGLICENSESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.UPDATEDRIVINGLICENSEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.UPDATEDRIVINGLICENSEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleDrivingLicense = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleDrivingLicense(id).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLEDRIVINGLICENSESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Status Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.TOGGLEDRIVINGLICENSEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.TOGGLEDRIVINGLICENSEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}